import { faStopwatch20 } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateCounters() {
    return (
        <div data-cy="historic-icon-updateCounters">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateCounters" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faStopwatch20} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
